import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { themeConfig } from '@gap/shared/theme'
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import ProposalAttachment from './ProposalAttachment'

interface ProposalAttachmentsPanelProps {
   proposal: ProposalDto
}

export default observer(function ProposalAttachmentsPanel({ proposal }: ProposalAttachmentsPanelProps) {
   const orgGuardStore = useOrgGuardStore()
   const attachments = proposal.step5?.attachments ?? []
   if (attachments.length === 0) return null

   const title = orgGuardStore.org?.orgType === 'advisor' ? 'Shared' : 'Shared with you'

   return <Box sx={{
      width: '100%',
      height: '100%',
      backgroundColor: themeConfig.light.background.alt,
      p: 3,
      overflowY: 'auto',
   }}>
      <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>
      {attachments.map((attachment, index) => (
         <ProposalAttachment
            key={`${attachment.fileName || attachment.link}-${index}`}
            attachment={attachment}
            proposal={proposal}
            canDelete={false}
         />
      ))}
   </Box>
})
